import axios from '@/utils/requset'
import { pageResponseHandler } from '@/utils/http'

const api = {
  list: { url: '/client/myCourse/list', method: 'get' },
  reassignList: { url: '/client/myCourse/reassignList', method: 'post' },
  reassignCourse: { url: '/client/myCourse/reassignCourse', method: 'post' },
  cancelCourse: { url: '/client/myCourse/cancel', method: 'post' },
  getCourseClassList: '/client/course/getCourseClassList',
  reassignCourseDetail: { url: '/client/myCourse/reassignCourseDetail', method: 'post' },
  getWholeCourseStudent: { url: '/client/myCourse/getWholeCourseStudent', method: 'get' },
}

export default {
  // 我选的课列表
  getMyCourseList(parameter) {
    return axios({
      url: api.list.url,
      method: api.list.method,
      params: parameter
    }).then(pageResponseHandler)
  },
  // 获取调课列表
  reassignList(parameter) {
    return axios({
      url: api.reassignList.url,
      method: api.reassignList.method,
      params: parameter
    }).then(pageResponseHandler)
  },
  // 调课选定
  reassignCourse(parameter) {
    return axios({
      url: api.reassignCourse.url,
      method: api.reassignCourse.method,
      data: parameter
    })
  },
  // 取消选课
  cancelCourse(parameter) {
    return axios({
      url: api.cancelCourse.url,
      method: api.cancelCourse.method,
      data: parameter
    })
  },
  // 去上课
  getCourseClassList(parameter) {
    return axios({
      url: api.getCourseClassList,
      method: 'get',
      params: parameter
    })
  },
  // 获取调课详情
  reassignCourseDetail(parameter) {
    return axios({
      url: api.reassignCourseDetail.url,
      method: api.reassignCourseDetail.method,
      params: parameter
    })
  },
  // 获取选课订单详情
  getWholeCourseStudent(parameter) {
    return axios({
      url: api.getWholeCourseStudent.url,
      method: api.getWholeCourseStudent.method,
      params: parameter
    })
  },
}